var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinIconFillAble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31886 7.35938C8.60539 7.35938 8.02661 7.92053 8.02661 8.61188V23.5923C8.02661 24.2837 8.60546 24.8444 9.31886 24.8444H24.2194C24.9331 24.8444 25.5116 24.2836 25.5116 23.5921V8.61188C25.5116 7.92053 24.9331 7.35938 24.2194 7.35938H9.31886ZM13.34 14.1203V21.9921H10.7235V14.1203H13.34ZM13.5125 11.6858C13.5125 12.4412 12.9445 13.0457 12.0323 13.0457L12.0152 13.0456C11.137 13.0456 10.5693 12.4412 10.5693 11.6857C10.5693 10.9132 11.1542 10.3256 12.0497 10.3256C12.9445 10.3256 13.4954 10.9132 13.5125 11.6858ZM17.4045 21.9921H14.7883C14.7883 21.9921 14.8225 14.859 14.7884 14.1205H17.4047V15.2348C17.7525 14.6985 18.375 13.9357 19.7628 13.9357C21.4842 13.9357 22.7748 15.0608 22.7748 17.4786V21.9921H20.1586V17.7813C20.1586 16.723 19.7797 16.0012 18.8332 16.0012C18.1103 16.0012 17.6798 16.488 17.4907 16.9582C17.4216 17.126 17.4045 17.3616 17.4045 17.5966V21.9921Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIconFillAble);
export default __webpack_public_path__ + "static/media/linkedinIconFillAble.5464d68b.svg";
export { ForwardRef as ReactComponent };